export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-00.5a712a88.jpg";